import * as yup from 'yup';

const requiredMessage = (fieldName) => `${fieldName} is required.`;

export const schema = yup.object().shape({
  email: yup.string().max(64).email('Email format is incorrect.').required(requiredMessage('Email')),
  password: yup.string().required(requiredMessage('Password')),
});